angular.module('zc.core')

.directive 'zcDirtyFormDialog', ($translate, NotificationChannel) ->
  restrict: 'A'
  link: (scope, element, attrs) ->
    isDirty = ->
      form = scope[element.attr('name')]
      form and form.$pristine == false

    doPrompt = ->
      if isDirty()
        return $translate.instant('sharedModules.core.directives.dirtyFormDialog')
      undefined

    $(window).bind('beforeunload', doPrompt);
    element.bind '$destroy', ->
      $(window).unbind('beforeunload', doPrompt);
    scope.$on '$stateChangeStart', (event, toState, toParams, fromState, fromParams) ->
      return if fromState is toState
      prompt = doPrompt()
      if prompt and !confirm(prompt)
        event.preventDefault()
        NotificationChannel.requestEnded()



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/directives/dirty_form_dialog.directive.coffee